import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';
import typography from './typography';

injectGlobal(`
  @media (min-width: 1700px) {
    .container {
      max-width: 1600px;
    }
  }
  .btn {
    background-color: ${colors.color1};
    transition: all .3s ease;
    color: #FFFFFF;
    &:hover {
      background-color: ${colors.color1Darkest};
      color: #FFFFFF;
    }
  }
  .btn-lg {
    text-align: center;
    padding: 40px;
    border: 1px solid ${colors.color1};
    transition: all .3s ease;
    background:${colors.color1};
    border-radius: 0;
    margin: 0 20px;
    color:white;
    cursor:pointer;
    font:700 18px/1 ${typography.SansSerif};
    text-transform:uppercase;
    @media (min-width: 991px) {
      font:700 24px/1 ${typography.SansSerif};
    }
    @media (min-width: 1600px) {
      margin: 0;
    }
    &:hover {
      background-color: ${colors.color1Darkest};
    }
  }
  .btn-dog {
    transition: all .3s ease;
    color: #FFFFFF;
    font:700 18px/1 ${typography.SansSerif};
    padding-bottom:5px;
    margin:0 30px;
    text-transform:uppercase;
    border-bottom:5px solid ${colors.color1};

    @media (min-width: 992px) {
      font:700 24px/1 ${typography.SansSerif};
    }

    &:hover {
      border-bottom:5px solid ${colors.color1Lightest};
      color: #FFFFFF;
    }
  }
  .notch-tl {
    -webkit-clip-path: polygon(0% 20px, 20px 0%, 100% 0, 100% 100%, 0 100%);
  }
  .notch-tr {
    -webkit-clip-path: polygon(0 0, calc(100% - 20px) 0%,  100% 20px, 100% 100%, 0 100%);
  }
  .notch-br {
    -webkit-clip-path: polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%);
    clip-path: polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%);
  }
  .notch-bl {
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 20px 100%, 0 calc(100% - 20px));
  }

  .form-control {
    height:60px;
  }
  .maxit {
    max-width:1600px;
    margin:0 auto;
    padding:0 20px;
  }
  .ReactModal__Overlay {
    background-color: rgba(1,35,64,0.75) !important;
  }
  .remove-row-neg-margins {
      margin-right:0;
      margin-left:0;
  }
`);

// .module {
//   clip-path:
//     polygon(
//       0% 20px,                 /* top left */
//       20px 0%,                 /* top left */
//       calc(100% - 20px) 0%,    /* top right */
//       100% 20px,               /* top right */
//       100% calc(100% - 20px),  /* bottom right */
//       calc(100% - 20px) 100%,  /* bottom right */
//       20px 100%,               /* bottom left */
//       0 calc(100% - 20px)      /* bottom left */
//     );
// }



// WEBPACK FOOTER //
// ./src/styles/reset.js